import toast from 'react-hot-toast';
import Core from '../core';
import { Axios, AxiosError, AxiosResponse } from 'axios';
const version = 'v2';

function getDigiSignatureList(empid: any, companyId: any, page: number, limit: number, search: any) {
  return new Promise((resolve, reject) => {
    const api = Core.getInstance().api();
    const params = {
      empId: empid,
      page,
      companyId,
      limit,
      searchTerm: search,
      locale: localStorage.getItem('applang'),
    };

    const query = Object.entries(params)
      .filter(([_, v]) => v) // remove undefined/null/empty
      .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
      .join('&');
    api
      .get(
        `/v2/digitalSignatureDocs?${query}`,
      )
      .then((result) => {
        return resolve(result.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function updateDigiSignature(attachment: any, id: any) {
  return new Promise((resolve, reject) => {
    const api = Core.getInstance().api();
    api
      .put(
        `/v2/digitalSignatureDocs/${id}`,
        attachment
      )
      .then((result) => {
        return resolve(result.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function getDigiSignLogs(companyId: any, id: number) {
  return new Promise((resolve, reject) => {
    const api = Core.getInstance().api();
    api
      .get(
        `/v2/digitalSignatureDocs/logs?id=${id}&companyId=${companyId}&locale=${localStorage.getItem(
          'applang',
        )}`,
      )
      .then((result) => {
        return resolve(result.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

function uploadSignature(payload: any, companyId: any) {
  return new Promise((resolve, reject) => {
    const api = Core.getInstance().multipartFormData();
    api
      .post(
        `/v2/file/upload?companyId=${companyId}&locale=${localStorage.getItem(
          'applang',
        )}`, payload
      )
      .then((result) => {
        return resolve(result.data);
      })
      .catch((err) => {
        return reject(err);
      });
  });
}

export const DigitalSignature = {
  getDigiSignatureList,
  getDigiSignLogs,
  uploadSignature,
  updateDigiSignature
};
